<template>
  <div class="info-panel">
    <template v-if="!errorMessage">
      <form @submit.prevent="searchVehicle">
        <div class="border rounded p-4 mb-5">
          <div class="row">
            <div class="col-6">
              <radio-field
                  v-model="filter.isNumber"
                  :value="true"
                  placeholder="Номер свидетельства"
                  type="checkbox"
                  id="vehicle.filter.isNumber_number"
              ></radio-field>
            </div>
            <div class="col-6">
              <radio-field
                  v-model="filter.isNumber"
                  :value="false"
                  placeholder="VIN"
                  type="checkbox"
                  id="vehicle.filter.isNumber_vin"
              ></radio-field>
            </div>
            <div class="col-6" v-if="!productType">
              <checkbox-field
                  v-model="filter.verify"
                  placeholder="Каз.учёт"
                  id="vehicle.filter.verify"
                  class="form-check-sm"
              />
            </div>
          </div>
        </div>
        <template v-if="filter.isNumber !== null">
            <input-field
                v-model="vehicle.number"
                id="vehicle.number"
                name="vehicle_number"
                :has-error="hasCar"
                :required="true"
                placeholder="Гос. номер авто"
                @input="vehicle.number=$event.target.value.toUpperCase()"
                type="text"
                mb="5">
              <div v-if="hasCar" class="invalid-feedback text-center opacity-75">
                {{ this.filter.isNumber ? 'Гост. номер' : 'VIN номер' }} <b>
                {{ this.filter.isNumber ? this.vehicle.number : this.vehicle.vin }}</b> уже указано.
              </div>
            </input-field>
          <template v-if="filter.isNumber">
            <input-field
                v-model="vehicle.certificate"
                id="vehicle.certificate"
                name="vehicle.certificate"
                :required="true"
                placeholder="Номер свидетельства"
                @input="vehicle.certificate=$event.target.value.toUpperCase()"
                type="text"
                mb="5">
            </input-field>
          </template>
          <template v-else>
            <input-field
                v-model="vehicle.vin"
                id="vehicle.vin"
                name="vehicle_vin"
                :has-error="hasCar"
                :required="true"
                placeholder="VIN"
                @input="vehicle.vin=$event.target.value.toUpperCase()"
                type="text"
                mb="5">
              <div v-if="hasCar" class="invalid-feedback text-center opacity-75">
                {{ this.filter.isNumber ? 'Гост. номер' : 'VIN номер' }} <b>
                {{ this.filter.isNumber ? this.vehicle.number : this.vehicle.vin }}</b> уже указано.
              </div>
            </input-field>
          </template>
          <button
              type="submit"
              class="btn btn-sm btn-primary w-100"
              :disabled="this.loading || this.hasCar"
              v-html="this.loading ? 'Идет поиск...' : 'Поиск'">
          </button>
        </template>
      </form>
    </template>
    <template v-else>
      <div class="text-gray-500 pt-3 text-center">
        <div class="text-gray-600 fs-5 fw-bold mb-5" v-html="errorMessage"></div>
        Вы можете
        <span class="text-danger cursor-pointer opacity-75 opacity-100-hover" @click="clearForm">сбросить форму</span>
        <span v-if="this.productType == 2 || this.productType == 3">
          или
          <span class="text-primary cursor-pointer opacity-75 opacity-100-hover" @click="createVehicle">создать авто</span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
// Field
import CheckboxField  from '@/components/Fields/CheckboxField.vue'
import InputField     from '@/components/Fields/InputField.vue'
import axios          from 'axios';
import RadioField from "@/components/Fields/RadioButtonField.vue";

export default {
  name: 'VehicleSearch',
  props: {
    isClear: {
      type: Boolean,
      default: false
    },
    carAddedList: {
      type: Array,
      default: () => []
    },
    productType: {
      type: Number,
      default: 0
    },
    module: {
      typ: Function,
      required: true
    }
  },
  components: {RadioField, InputField, CheckboxField},
  data () {
    return {
      filter: {
        verify: true,
        isNumber: null
      },
      vehicle: {
        number:      null,
        vin:         null
      },
      errorMessage: null,
      loading:      false,
      hasCar:       false,
      valid:        false,
      step:         0,
    }
  },
  methods: {
    searchVehicle() {
      let value   = this.filter.isNumber ? this.vehicle.number : this.vehicle.vin
      this.hasCar = this.carAddedList.indexOf(value) >= 0
      if (!this.hasCar) {
        this.loading  = true
        const headers = Object.assign(structuredClone(this.filter), structuredClone(this.vehicle))
        axios.post('/api/vehicle/get', headers)
            .then(res => {
              if (res.data.length > 0) {
                Object.keys(res.data).forEach((key) => {
                  res.data[key].number              = res.data[key].number ? res.data[key].number : (this.filter.isNumber ? this.vehicle.number : null)
                  res.data[key].registration.number = res.data[key].number
                })
                this.$emit('createVehicle', {data:res.data, step:1})
              } else {
                this.info         = null
                this.errorMessage = `Авто не найдено`
              }
              this.loading = false
            })
            .catch(() => {
              this.errorMessage = `Авто не найдено`
              this.loading      = false
            })
      }
    },
    clearForm() {
      this.filter       = {verify: !(this.productType === 2 || this.productType === 3), isNumber: null}
      this.vehicle      = {certificate:null, number:null}
      this.errorMessage = null
      this.loading      = false
      this.step         = 0
    },
    createVehicle() {
      this.$emit('createVehicle', {data:[this.module.Vehicle.empty()], step:1})
    }
  },
  watch: {
    'filter.isNumber': {
      deep: true,
      handler(newValue) {
        this.vehicle = this.module.Vehicle.searchValues(newValue)
      }
    },
    vehicle: {
      deep: true,
      handler() {
        this.hasCar = false
      }
    },
    isClear: {
      deep: true,
      handler(val) {
        if (val) {
          this.clearForm()
        }
      }
    },
    productType: {
      immediate: true,
      handler(val) {
        this.filter.verify = !(val === 2 || val === 3)
        this.isNumber = this.filter.verify
      }
    },
    'vehicle.number': {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.vehicle.number = val.replaceAll(/[^\p{L}\p{N}\p{Pd}\u2212]/gu, '');
          });
        }
      }
    },
    'vehicle.vin': {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.vehicle.vin = val.replaceAll(/[^\p{L}\p{N}\p{Pd}\u2212]/gu, '');
          });
        }
      }
    }
  }
}
</script>

<style scoped>

</style>